import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';

function AnuncioBanner() {
  const [anuncios, setAnuncios] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchAnuncios = async () => {
      try {
        const res = await axios.get(`${API}/anuncios`);
        setAnuncios(res.data);
      } catch (error) {
        console.error('Error cargando anuncios:', error);
      }
    };
    fetchAnuncios();
  }, []);

  // Rotar anuncios cada 10 segundos si hay más de uno
  useEffect(() => {
    if (anuncios.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % anuncios.length);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [anuncios.length]);

  if (anuncios.length === 0) return null;

  const anuncioActual = anuncios[currentIndex];

  return (
    <div className="w-full my-4">
      <a 
        href={anuncioActual.enlace} 
        target="_blank" 
        rel="noopener noreferrer"
        className="block"
      >
        <div className="relative overflow-hidden rounded-xl border border-gray-700 hover:border-gold transition-colors group">
          <img 
            src={anuncioActual.imagen_url} 
            alt="Anuncio"
            className="w-full h-auto max-h-32 object-cover group-hover:scale-105 transition-transform duration-300"
          />
          <div className="absolute top-2 right-2 bg-black/50 text-gray-400 text-xs px-2 py-0.5 rounded">
            Publicidad
          </div>
          {anuncios.length > 1 && (
            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
              {anuncios.map((_, idx) => (
                <div 
                  key={idx}
                  className={`w-2 h-2 rounded-full transition-colors ${idx === currentIndex ? 'bg-gold' : 'bg-gray-600'}`}
                />
              ))}
            </div>
          )}
        </div>
      </a>
    </div>
  );
}

export default AnuncioBanner;
